import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Download } from './Download'
import { Hero } from './Hero'
import { PressList } from './PressList'
import { PressProps } from './types'

export const Press: FC<PressProps> = ({
  seo,
  header,
  footer,
  content: { breadcrumb, hero_image, tag, title, subtitle, label_button, press, download }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Hero
      breadcrumb={breadcrumb}
      hero_image={hero_image}
      tag={tag}
      title={title}
      subtitle={subtitle}
      label_button={label_button}
    />
    <PressList press={press} />
    <Download download={download} />
  </Page>
)
